



















































































































































import Vue from 'vue'
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import {API} from 'aws-amplify'
import QRCode from 'qrcode'

const STOCK_HOLDER_LENGTH = 9
const POSTAL_CODE_FIRST_LENGTH = 3
const POSTAL_CODE_SECOND_LENGTH = 4
const ERROR_MESSAGE_NUMBER_VALIDATION = '半角数字でご入力ください'
const ERROR_MESSAGE_ALPHANUMERIC_VALIDATION = '半角英数字でご入力ください'
const ERROR_MESSAGE_SEARCH_FAILURE = 'キーに照合しません。ご入力内容をご確認ください。'
const ERROR_MESSAGE_NETWORK_FAILURE = '通信に失敗しました。'
const DEFAULT_CONSULTANT_KEY = '・・・・・・'

export default Vue.extend({
  name: 'App',
  components: {
    Header,
    Footer,
  },
  props: {},
  data() {
    return {
      // フォーム入力チェック（trueで相談キー取得ボタンが押せる様になる）
      valid: false,
      // 通信中（相談キー取得ボタンの表示切替用）
      loading: false,
      // 相談キー
      consultantKey: DEFAULT_CONSULTANT_KEY,
      // qrコードのimg src
      qrCodeImageSrc: '',
      // テキストコピー直後の判定
      copied: false,

      // 株主番号
      stockholderId: '',
      stockholderIdRules: [
        v => !!v || ERROR_MESSAGE_NUMBER_VALIDATION, // 未入力チェック
        v => v.search(/[^0-9０-９]/) < 0 || ERROR_MESSAGE_NUMBER_VALIDATION, // 半角数字チェック
      ],

      // 郵便番号
      postalCodeFirst: '',
      postalCodeFirstRules: [
        v => !!v || ERROR_MESSAGE_NUMBER_VALIDATION, // 未入力チェック
        v => v.search(/[^0-9０-９]/) < 0 || ERROR_MESSAGE_NUMBER_VALIDATION, // 半角数字チェック
        v => (v || '').length == POSTAL_CODE_FIRST_LENGTH || ERROR_MESSAGE_NUMBER_VALIDATION, // 桁数チェック
      ],
      postalCodeSecond: '',
      postalCodeSecondRules: [
        v => !!v || ERROR_MESSAGE_NUMBER_VALIDATION, // 未入力チェック
        v => v.search(/[^0-9０-９]/) < 0 || ERROR_MESSAGE_NUMBER_VALIDATION, // 半角数字チェック
        v => (v || '').length == POSTAL_CODE_SECOND_LENGTH || ERROR_MESSAGE_NUMBER_VALIDATION, // 桁数チェック
      ],

      // リーフレット番号
      leafletId: '',
      leafletIdRules: [
        v => !!v || ERROR_MESSAGE_ALPHANUMERIC_VALIDATION, // 未入力チェック
        v => v.search(/[^0-9a-zA-Z]/) < 0 || ERROR_MESSAGE_ALPHANUMERIC_VALIDATION, // 半角英数字チェック
      ],

      // 相談キー取得時のエラーメッセージ
      errorMessages: {
        consultantKey: ''
      }
    }
  },
  computed: {
    // 入力を半角数値に変換して扱う
    stockholderIdText: {
      get: function () {
        return this.stockholderId
      },
      set: function (v: string) {
        this.stockholderId = this.toHalfWidthNumber(v)
      }
    },
    postalCodeFirstText: {
      get: function () {
        return this.postalCodeFirst
      },
      set: function (v: string) {
        this.postalCodeFirst = this.toHalfWidthNumber(v)
      }
    },
    postalCodeSecondText: {
      get: function () {
        return this.postalCodeSecond
      },
      set: function (v: string) {
        this.postalCodeSecond = this.toHalfWidthNumber(v)
      }
    },
    // leafletIdText: {
    //   get: function () {
    //     return this.leafletId
    //   }
    //   ,
    //   set: function (v: string) {
    //     // 大文字変換
    //     this.leafletId = v.toUpperCase()
    //   }
    // },
    // 相談キーがデフォルト値かどうか判定する
    isDefaultConsultantKey: function (): boolean {
      return this.consultantKey === DEFAULT_CONSULTANT_KEY
    },

    // エラーかどうか
    isError: function(): boolean {
      return this.errorMessages.consultantKey !== ''
    }
  },
  watch: {
    stockholderId: function () {
      // 入力されているかつエラーでなければ次へフォーカスする
      if (this.stockholderId.length === STOCK_HOLDER_LENGTH && this.$refs.stockholder.valid) {
        this.$refs.postalCodeFirst.focus()
      }
      // エラー時のフォーム状態更新
      this.validateFormIfError()
    },
    postalCodeFirst: function () {
      // validate()実行しないと、watch時点では桁数チェックが反映されていなかった
      if (this.postalCodeFirst.length == POSTAL_CODE_FIRST_LENGTH && this.$refs.postalCodeFirst.validate()) {
        this.$refs.postalCodeSecond.focus()
      }
      // エラー時のフォーム状態更新
      this.validateFormIfError()
    },
    postalCodeSecond: function () {
      // validate()実行しないと、watch時点では桁数チェックが反映されていなかった
      if (this.postalCodeSecond.length == POSTAL_CODE_SECOND_LENGTH && this.$refs.postalCodeSecond.validate()) {
        this.$refs.leafletId.focus()
      }
      // エラー時のフォーム状態更新
      this.validateFormIfError()
    },
    leafletId: function () {
      // エラー時のフォーム状態更新
      this.validateFormIfError()
    }
  },

  methods: {
    // 相談キーの取得
    getConsultantKey: async function () {
      try {
        // 通信中
        this.loading = true
        // QRコードを削除
        this.qrCodeImageSrc = ''
        // 相談キーを削除
        this.consultantKey = DEFAULT_CONSULTANT_KEY
        // エラーメッセージを削除
        this.clearErrorMessages()

        // 相談キー取得API
        this.consultantKey = await API.get('consultantKey', '/items', {
          'queryStringParameters': {
            'stockholderId': this.stockholderId,
            'postalCode': this.postalCodeFirst + this.postalCodeSecond,
            'leafletId': this.leafletId
          }
        })

        // 相談キーからQRコード生成
        this.qrCodeImageSrc = await QRCode.toDataURL(this.consultantKey);

      } catch (e) {
        console.log('Error: ', e.message)
        const message = e.message
        if (message.indexOf('404') >= 0) {
          this.errorMessages.consultantKey = ERROR_MESSAGE_SEARCH_FAILURE
        } else {
          this.errorMessages.consultantKey = ERROR_MESSAGE_NETWORK_FAILURE
        }

        // 失敗時は再入力までボタンを無効化する
        this.valid = false
      } finally {
        // 通信中を解除
        this.loading = false
      }
    },

    // 相談キーをクリップボードにコピーする
    copyText: async function () {
      try {
        await this.$copyText(this.consultantKey)
        this.copied = true

        // 一定時間で戻す
        setTimeout(() => {
          this.copied = false
        }, 2000)
      } catch (e) {
        console.log(e)
      }
    },

    // 全角数値を半角数値に変換する
    toHalfWidthNumber: function (v: string) {
      return v.replace(/[０-９]/g, function (s: string) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      })
    },

    // 全角英数字を半角英数字に変換する
    // これはそのまま使うとスマートフォンで全角入力時に不正な動作をしたので、未使用
    toHalfWidthAlphanumeric: function (v: string) {
      return v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
    },

    // 株主番号の先頭桁数の補完
    leftPadStockholderId: function () {
      // 1桁でも入力されていて、エラーがなければ補完する
      if (this.stockholderId.length > 0 && this.$refs.stockholder.valid) {
        this.stockholderId = this.stockholderId.padStart(STOCK_HOLDER_LENGTH, '0')
      }
    },

    // エラー中の場合は、form状態を更新する
    validateFormIfError: function () {
      // 相談キー取得失敗時に、再入力までボタンを非有効化しているため
      if (this.isError) {
        this.valid = this.$refs.form.validate()
        // エラー文言削除
        this.clearErrorMessages()
      }
    },

    // エラーメッセージをクリアする
    clearErrorMessages: function () {
      this.errorMessages.consultantKey = ''
    }
  }
});
